<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="520px" class="dialog">
      <v-card>
        <v-card-title class="title-div">
          <p class="title mb-0 mr-1" v-if="showResultDeny()">{{$t('audit.titleDeny')}} </p><p class="title mb-0" style="display:inline-block" v-if="showResultDeny()"> {{name}}?</p>
          <p class="title mb-0 mr-1" v-if="showResultApprove()">{{approveTitle }} </p><p class="title mb-0" v-if="showResultApprove()"> {{name}}?</p>
        </v-card-title>
        <v-card-text class="ma-0 py-0">
          <v-container class="ma-0 py-0">
            <v-row class="ma-0 py-0">
             <!-- <v-col cols="12" sm="6" md="6">
                <v-select
                  :items="items"
                  :label="$t('audit.subtitle')"
                  v-model="resultDisplay"
                  required
                ></v-select>
              </v-col>-->
              <v-col cols="12" class="py-0 my-0">
                <p class="message py-0 my-0"> {{message}}</p>
              </v-col>
            </v-row>
            <v-row v-if="!result">
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  outlined
                  name="input-7-4"
                  :label="$t('audit.resultDescription')"
                  v-model="reason"
                  ref="reasonTextArea"
                  height="100"
                  class="text-area"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="buttons py-4">
          <v-btn text @click="dialog = false" class="btn btn-cancel">{{$t('cancelButton')}}</v-btn>
          <v-btn rounded dark @click="sendResults" class="btn btn-confirm px-5 py-2">{{$t('audit.saveButton')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      result: true,
      reason: '',
      items: [],
      name: ''
    }
  },
  mounted(){
    this.result = this.$store.getters.getAuditResult
    this.checkItems();
  },
  computed:{
    dialog: {
      get(){
        return this.$store.getters.getAuditDialog
      },
      set(value){
        return this.$store.commit('setAuditDialog', value)
      }
    },
    resultDisplay: {
      get(){
        if(this.isLegalAudit){
          return (this.result)? this.$t('audit.approve'):this.$t('audit.deny')
        }
        else {
          return (this.result)? this.$t('audit.preApprove'):this.$t('audit.deny')
        }
      },
      set(value){
        return (value==this.$t('audit.preApprove')|| value==this.$t('audit.approve'))? this.result=true: this.result=false
      }
    },
    project: {
      get(){
        return this.$store.getters.getAuditProject
      }
    },
    message: {
      get(){
        if(this.isLegalAudit){
          return (this.result)? this.$t('audit.approveText'):this.$t('audit.denyText')
        }
        else {
          return (this.result)? this.$t('audit.preApproveText'):this.$t('audit.denyText')
        }
      }
    },
    approveTitle(){
      if(this.isLegalAudit){
        return (this.result)? this.$t('audit.titleApprove'):this.$t('audit.deny')
      }
      else {
        return (this.result)? this.$t('audit.titlePreApprove'):this.$t('audit.deny')
      }
    },
    isLegalAudit: {
      get(){
        return this.$store.getters.getIsLegalAudit
      }
    }
  },
  methods: {
    async sendResults(){
      if(!this.isLegalAudit){
        await this.$extractions.sendAuditResults(this.project, this.result,
        this.reason)
        .then(()=>{
          this.$emit('refreshData')
          this.$store.dispatch('snackAlert', true)
          this.dialog = false
        })
        .catch(()=> {
          this.$store.dispatch('snackAlert', false)
          this.dialog = false
        })
      } else {
        await this.$extractions.sendLegalAuditResults(this.project, this.result,
        this.reason)
        .then(()=>{
          this.$emit('refreshData')
          this.$store.dispatch('snackAlert', true)
          this.dialog = false
        })
        .catch(()=> {
          this.$store.dispatch('snackAlert', false)
          this.dialog = false
        })
      }
      
    },
    checkItems(){
      
      if(this.isLegalAudit){
        if (this.project.status === 'Approved'){
          this.items.push(this.$t('audit.deny')) 
        } else if (this.project.status === 'Denied'){
          this.items.push(this.$t('audit.approve'))
        } else if (this.project.status ==="PreApproved"){
          this.items.push(this.$t('audit.approve'))
          this.items.push(this.$t('audit.deny')) 
        }
      } else {
        if (this.project.status === 'PreApproved'){
          this.items.push(this.$t('audit.deny')) 
        } else if (this.project.status === 'Denied'){
          this.items.push(this.$t('audit.preApprove'))
        } else if (this.project.status ==="Finished"){
          this.items.push(this.$t('audit.preApprove'))
          this.items.push(this.$t('audit.deny')) 
        }
      }
      return this.items
    },
    showResultDeny() {
      if (this.result === false && this.project.name !== undefined) {
        this.name = this.project.name
        return true
      } else if(this.result === false && this.project.projectName !== undefined) {
        this.name = this.project.projectName
        return true
      } else {
        return false
      }
    },
    showResultApprove() {
      if (this.result === true && this.project.name !== undefined) {
        this.name = this.project.name
        return true
      } else if (this.result === true && this.project.projectName !== undefined){
        this.name = this.project.projectName
        return true
      } else {
        return false
      }
    }
  }

}
</script>
<style>
  
  .title-div{
    justify-content: center;
  }
  .title{
    font-size: 16px!important;
  }
  .v-application .title{
    color:#24243a;
    font-size: 16px!important;
  }
  .message{
    font-size: 11px;
  }
  .v-dialog--active{
    border-radius: 20px;
    text-align: center;
  }
  .buttons{
    justify-content: center;
  }
  .btn{
    font-size: 12px!important;
    font-family: 'Roboto', 'sans-serif'!important;
  }
  .btn-cancel{
    color: #91919c!important;
  }
  .btn-cancel:hover{
    color: #65656d!important;
  }
  .btn-cancel::before{
    background-color: transparent!important;
  }
  .btn-confirm{
    background-color: #5f98ed!important;
  }
  .btn-confirm:hover{
    background-color: #4681da!important;
    color: #fff!important;
  }
  @media (max-width: 700px) {
    .v-application .title{
      font-size: 14px!important;
    }
    .text-area .v-label{
      font-size: 14px!important;
    }
    .row{
      margin-right: 0!important;
    }
    .btn .v-btn__content{
      font-size: 12px!important;
      padding-left: 6px;
      padding-right: 6px;
    }
  }
  @media (max-width: 600px) {
    .v-application .title{
      font-size: 12px!important;
    }
    .text-area .v-label{
      font-size: 12px!important;
    }
    .btn .v-btn__content{
      font-size: 10px!important;
    }
  }
  @media (max-width: 500px) {
    .v-application .title{
      font-size: 11px!important;
    }
    .text-area .v-label{
      font-size: 11px!important;
    }
    .title-div{
      padding: 1px!important;
    }
  }
  @media (max-width: 350px) {
    .v-application .title{
      font-size: 10px!important;
    }
    .text-area .v-label{
      font-size: 10px!important;
    }
  }
</style>

